import React, { Fragment } from "react";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import Image from "@/component/c-image";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import { useDispatch } from "react-redux";
import Icon from "@gc-npm/components.icon-glyph";
import Label, { LABEL_SHAPES, LABEL_TYPES } from "@gc-npm/components.cms-block.cms-label";
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_KIND,
  TEXT_HEADING_LEVEL,
} from "@gc-npm/components.text";
import Price, { PRICE_SIZE } from "@gc-npm/components.price";
import CustomLink from "@gc-npm/components.custom-link";
const RegulatoryInfoModal = dynamic(() => import("@/modals/regulatory-info"));
import Card from "@/component/card";

import styles from "./style";

const DeviceCard = ({
  onClick,
  href,
  hash,
  cydata,
  labelPromo,
  labelSaving,
  prePriceLabel,
  image,
  name,
  pretitle,
  bottomCardText,
  wrapperClass,
  offers,
  stamp,
  regulatoryInfo
}) => {
  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(modalActions.addModal({ id: "" }));
    //onCloseHandler();
  };

  const launchRegulatoryInfoModal = (productRegulatoryInfo) => {
    dispatch(
      modalActions.addModal({
        id: "RegulatoryInfoModal",
        Element2Show: RegulatoryInfoModal,
        modalProps: {
          ariaLabel: "Eficiencia energética",
          historyBackOnClose: false,
          contentPosition: window.innerWidth <= 768 ? "center--bottom" : "right--center",
          inSceneEffect: "fadeIn",
          className: "RegulatoryInfoModalContent",
          outSceneEffect: "fadeOut",
          opacityLayoutColor: "darkblue",
          closeByClickingOutside: true,
        },
        elementProps: {
          closeModal,
          regulatoryInfo: productRegulatoryInfo,
        },
      })
    );
  };

  return (
    <>
      <section className={`device-card ${wrapperClass || ""}`} data-cy={cydata}>
        <Card
          className="device-card-position device-card-height"
          cardPropLayout="device"
          title={name}
          taggingInfo={{
            componentContent: `Dispositivo ${name}`,
            componentName: "device-card",
          }}
          isDeviceCard
        >
          {labelPromo && labelPromo.text && (
            <Label
              cydata="labelPromoEntrega"
              type={LABEL_TYPES.ACTIVE}
              shape={LABEL_SHAPES.TEARS}
              text={labelPromo.text}
              textSize={TEXT_SIZE.TEXT_PRESET_01}
            />
          )}
          <div className="device-card--container">
            <div className="device-card--container--image-stamp-container">
              {stamp && stamp.icon ? (
                <div className="device-card--container--image-stamp-container--stamp" style={{ justifyContent: stamp.align }}>
                  <Icon
                    id={stamp.icon}
                    width={stamp.width || 200}
                    height="auto"
                    position="right"
                  />
                </div>
              ) : (
                stamp && stamp.img && (
                  <div
                    className="device-card--container--image-stamp-container--stamp"
                    style={{ justifyContent: stamp.align }}
                    aria-hidden={true}
                  >
                    <Image
                      src={stamp.img}
                      title={name}
                      alt={name}
                      hash={hash}
                      height={100}
                      width={stamp.width || 200}
                      cydata="mainImageCardIn"
                    />
                  </div>
                )
              )}
              <div
                className={`device-card--container--image-stamp-container--image-box ${stamp ? 'with-stamp' : ''}`}
                data-cy="mainImageCard"
                aria-hidden={true}
              >
                <Image
                  src={image}
                  title={name}
                  alt={name}
                  hash={hash}
                  objectFit="contain"
                  fill
                  sizes="230px"
                  cydata="mainImageCardIn"
                />
              </div>
            </div>
            <div className="device-card--container--pretitle">
              <TextInfo
                text={pretitle}
                size={TEXT_SIZE.TEXT_PRESET_01}
                color={TEXT_COLOR.GREY_500}
                kind={TEXT_KIND.HEADING}
                level={TEXT_HEADING_LEVEL.H3}
                cydata="productPretitle"
              />
            </div>
            <div
              className="device-card--container--name"
              data-cy="productNameTitle"
            >
              <CustomLink
                href={href}
                title={name}
                taggingInfo={{
                  componentContent: `Dispositivo ${name}`,
                  componentName: "device-card",
                }}
                className="absolute-link"
              >
                <TextInfo
                  className="device-card--container--name--text"
                  onClick={onClick}
                  href={href}
                  text={name}
                  size={TEXT_SIZE.TEXT_PRESET_03}
                  color={TEXT_COLOR.MOVISTAR_BLACK}
                  fontType={TEXT_FONT_WEIGHT.BOLD}
                  kind={TEXT_KIND.HEADING}
                  level={TEXT_HEADING_LEVEL.H3}
                  cydata="productNameTitleIn"
                />
              </CustomLink>
            </div>
            <div
              className="device-card--container--label"
              data-cy="labelPrePrice"
            >
              <Label
                type={LABEL_TYPES.ACTIVE}
                text={prePriceLabel}
                textSize={TEXT_SIZE.TEXT_PRESET_01}
                notBorderRadius
                cydata="labelPrePriceIn"
              />
            </div>
            <div
              className="device-card--container--label"
              data-cy="labelPromoAhorro"
            >
              <Label
                type={LABEL_TYPES.PROMOCION}
                textSize={TEXT_SIZE.TEXT_PRESET_01}
                text={labelSaving}
                notBorderRadius
                cydata="labelPromoAhorroIn"
              />
            </div>
            {stamp && stamp.postSavingText && (
              <div
                className="device-card--container--post-saving"
                data-cy="productPostSaving"
              >
                <TextInfo
                  className="device-card--container--post-saving--text"
                  text={stamp.postSavingText}
                  size={TEXT_SIZE.TEXT_PRESET_01}
                  color={TEXT_COLOR.RED_DARK}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                  kind={TEXT_KIND.HEADING}
                  level={TEXT_HEADING_LEVEL.H3}
                  cydata="productPostSavingIn"
                />
              </div>
            )}
            {
              offers && Object.keys(offers).map((offerKey, index) => (
                offers[offerKey] && (offers[offerKey].finalPrice != null || offers[offerKey].monthlyFinalPrice != null) && (
                  <div className="device-card--container--offer" key={offerKey}>
                    {offers[offerKey].isSwapOffer && (
                      <div className="device-card--container--label">
                        <Image
                          src={"/content/dam/movistar/icons/movistar-swap.svg"}
                          title={"Movistar Swap"}
                          alt={"Movistar Swap"}
                          height={100}
                          width={115}
                          cydata="swapOfferStamp"
                        />
                      </div>
                    )}
                    {offers[offerKey].title && (
                      <div className="device-card--container--pack-title">
                        <TextInfo
                          text={offers[offerKey].title}
                          size={TEXT_SIZE.TEXT_PRESET_01}
                          color={TEXT_COLOR.GREY_600}
                          fontType={TEXT_FONT_WEIGHT.REGULAR}
                        />
                      </div>
                    )}
                    <div
                      className="device-card--container--price-box"
                      data-cy="priceBox"
                    >
                      {offers[offerKey].finalPriceBeforeDiscounts != null && !offers[offerKey].compact && (
                        <>
                          <div
                            className="device-card--container--price-box--relative device-card--container--previous-price"
                            data-cy="normalFreePriceBefore"
                          >
                            <Price
                              price={offers[offerKey].finalPriceBeforeDiscounts}
                              currency={`€`}
                              size={PRICE_SIZE.XS}
                              color={TEXT_COLOR.GREY_600}
                              fontType={TEXT_FONT_WEIGHT.REGULAR}
                              cydata="normalFreePriceBeforeIn"
                            />
                          </div>
                        </>
                      )}
                      {!offers[offerKey].compact && (
                        <>
                          <div
                            className="device-card--container--price-box--relative"
                            data-cy="normalPriceBefore"
                          >
                            <Price
                              price={offers[offerKey].finalPrice ?? offers[offerKey].monthlyFinalPrice}
                              currency={offers[offerKey].finalPrice != null ? `€` : offers[offerKey].monthlyFinalPrice != null ? `€/mes` : ""}
                              size={PRICE_SIZE.S}
                              color={TEXT_COLOR.MOVISTAR_BLACK}
                              fontType={TEXT_FONT_WEIGHT.BOLD}
                              cydata="normalPriceBeforeIn"
                            />
                          </div>
                          <TextInfo
                            className="device-card--container--price-box--month-quota"
                            text={offers[offerKey].installmentsText}
                            size={TEXT_SIZE.TEXT_PRESET_01}
                            color={TEXT_COLOR.GREY_600}
                          />
                        </>
                      )}
                    </div>
                    {
                      offers[offerKey].afterOfferText && (
                        <div
                          className="device-card--container--after-price-text"
                          data-cy="normalAfterPriceText"
                        >
                          <TextInfo
                            text={offers[offerKey].afterOfferText}
                            size={TEXT_SIZE.TEXT_PRESET_01}
                            color={TEXT_COLOR.RED_DARK}
                            fontType={TEXT_FONT_WEIGHT.REGULAR}
                          />
                        </div>
                      )
                    }
                    {(offerKey === "r2r" || offerKey === "r2rAdditional") && offers.libre && (
                      <div className="device-card--container--line-freeOffer" />
                    )}
                  </div>
                )
              ))
            }
          </div>

          <>

            {bottomCardText && (
              <div className="device-card--container--bottom-text">
                {/* Si hay oferta de libre, requiere añadir separador superior*/}
                <div className="device-card--container--line-freeOffer" />
                <TextInfo
                  text={bottomCardText}
                  className="additionalPayment"
                  size={TEXT_SIZE.TEXT_PRESET_01}
                  color={TEXT_COLOR.GREY_600}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                />
              </div>
            )}
            {
              regulatoryInfo &&
              regulatoryInfo.regulatoryInfo_url_AEM_miniatura && (

                <div className="device-card--container--eficiency-label">
                  <CustomLink
                    taggingInfo={{
                      componentContent: "Información regulatoria",
                      componentName: "product-card",
                    }}
                    onClick={() => launchRegulatoryInfoModal(regulatoryInfo)}
                  >
                    <Image
                      src={regulatoryInfo.regulatoryInfo_url_AEM_miniatura}
                      alt={`Etiqueta energética clase ${regulatoryInfo.regulatoryInfo_efficiencyClass} del ${name}`}
                      height={40}
                      width={40}
                    />
                  </CustomLink>
                </div>
              )
            }
          </>
        </Card>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};


DeviceCard.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string.isRequired,
  hash: PropTypes.string,
  cydata: PropTypes.string,
  labelPromo: PropTypes.shape({
    text: PropTypes.string.isRequired,
    kind: PropTypes.string,
  }),
  labelSaving: PropTypes.string,
  prePriceLabel: PropTypes.string,
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  bottomCardText: PropTypes.string,
  wrapperClass: PropTypes.string,
  offers: PropTypes.objectOf(PropTypes.shape({
    title: PropTypes.string,
    finalPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    finalPriceBeforeDiscounts: PropTypes.number,
    currency: PropTypes.string,
    quote: PropTypes.string,
  })),
};

DeviceCard.defaultProps = {
  hash: "",
  cydata: "",
  labelPromo: null,
  labelSaving: "",
  prePriceLabel: "",
  bottomCardText: "",
  wrapperClass: "",
  offers: null,
};

export default DeviceCard;
